var React = require( 'react' );
var createReactClass = require('create-react-class');

var Transition  = createReactClass({

  render: function(){
    return (
      <div />
    );
  }
});

module.exports = Transition ;



// WEBPACK FOOTER //
// ./src/common/routes/survey/components/field-types/text/transition.jsx